import { HStack, View, Box, useTheme, IconButton, CloseIcon, IIconProps, Center } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Button, Text, UploadCloudIcon } from '@pimm/base';

type PromptConfirmationProps = {
  _close?: { text?: string };
  _confirm?: { text?: string };
  _icon?: React.ReactNode;
  _iconProps?: IIconProps;
  hideCancel?: boolean;
  title?: string;
  message?: string | React.ReactNode;
  onClose?: () => void;
  onConfirm?: () => void;
};

export const PromptConfirmation = ({
  _close,
  _confirm,
  _icon,
  _iconProps,
  hideCancel,
  message,
  title,
  ...props
}: PromptConfirmationProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const colorScheme = _iconProps?.colorScheme ?? 'warning';

  return (
    <View position="relative" px={6} pt={4}>
      <HStack alignItems="flex-start" justifyContent="space-between" mb={4}>
        <Center boxSize={10} rounded="full" bg={`${colorScheme}.50`}>
          <Center boxSize={8} rounded="full" bg={`${colorScheme}.100`}>
            {_icon ?? <UploadCloudIcon size={18} color={colors.warning[600]} {..._iconProps} />}
          </Center>
        </Center>

        {!!props.onClose && (
          <IconButton
            rounded="lg"
            variant="unstyled"
            position="absolute"
            boxSize={8}
            p={0}
            top={-2}
            right={-8}
            _pressed={{ bg: 'gray.50' }}
            icon={<CloseIcon size="18px" color={colors.gray[700]} />}
            onPress={props.onClose}
          />
        )}
      </HStack>

      <Box mb={3}>
        <Text color="black" fontWeight={600} size="xl" mb={2} lineHeight="sm">
          {title}
        </Text>
        {typeof message === 'string' ? (
          <Text color="gray.900" fontWeight={500} size="md" mb={3} lineHeight="sm">
            {message}
          </Text>
        ) : (
          message
        )}
      </Box>

      <HStack space={2} pt={1} pb={5}>
        {!hideCancel && (
          <Button flex={1} size="lg" variant="unstyled" borderColor="gray.300" bg="white" shadow={1} onPress={props.onClose}>
            {_close?.text ?? t('app:cancel')}
          </Button>
        )}
        <Button flex={1} size="lg" shadow={0} onPress={props.onConfirm}>
          {_confirm?.text ?? t('app:confirm')}
        </Button>
      </HStack>
    </View>
  );
};
